var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"main"},[_c('retouches')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }